import { useMemo } from "react";
import { createTreeFromPositions } from "../helpers/tree.helpers";
import { NodeMap } from "src/types/node.types";
import type { CanvasPositionMap } from "src/features/editor";

export function useTree(positions: CanvasPositionMap, nodes: NodeMap) {
  return useMemo(
    () => createTreeFromPositions(positions, nodes),
    [positions, nodes]
  );
}
